import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import * as React from 'react';
import { Suspense } from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { store } from '../web-legacy/appStore';
import { ErrorFallback } from '../web-legacy/packages/contactUs/presentationalComponents/ErrorFallback';
import { appContext } from './models/getHelp/appContext';
import { loadEmerald } from './utils/bootstrap';
import { isLoadResourcesEnabled, loadResources } from './utils/stringLoader';

const AppInitializerContainer = React.lazy(async () => {
  const module = await import('../web-legacy/packages/app/containerComponents/appInitializerContainer');
  return { default: module.AppInitializerContainer };
});

const emeraldWeb = (
  <ErrorFallback>
    <Suspense fallback={null}>
      {
        <Provider store={store}>
          <AppInitializerContainer />
        </Provider>
      }
    </Suspense>
  </ErrorFallback>
);

const loadBundleWithResources = async (locale: string) => {
  try {
    await loadResources(locale, appContext.distUrl);
    render(emeraldWeb, document.getElementById('root'));
  } catch (error) {
    // handle error
  }
};

if (isLoadResourcesEnabled) {
  loadEmerald(loadBundleWithResources);
} else {
  render(emeraldWeb, document.getElementById('root'));
}
